/* eslint-disable no-undef */
/* eslint-disable no-plusplus */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import SurveyPage from '../pages/SurveyPage';
import ResultsPage from '../pages/ResultsPage';
import About from '../pages/AboutUs';
import Faq from '../pages/Faq';
import Dashboard from '../pages/Dashboard';
import LandingPage from '../pages/LandingPage';
import Modal from '../pages/modals/RootModal';
import {
  getAllSurveys, signinUser, getUserData,
} from '../actions';
import AllSurveys from '../pages/AllSurveys';
import PrivateRoute from './PrivateRoute';
import Profile from '../pages/settings-page/Profile';
import NavBar from './NavBar';
import Notifications from '../pages/settings-page/Notifications';
import Password from '../pages/settings-page/Password';
import Demographics from '../pages/settings-page/Demographics';
import '../beeline.min';
import FourOhFour from '../pages/FourOhFour';
import Favorites from '../pages/Favorites';

class App extends Component {
  componentDidMount() {
    const userid = localStorage.getItem('userid');
    const token = localStorage.getItem('token');
    if (token && userid) {
      this.props.getUserData(userid);
      this.props.getAllSurveys();
    }
    window.addEventListener('resize', this.appHeight);
    this.appHeight();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.auth && this.props.auth) {
      this.props.getUserData(localStorage.getItem('userid'));
      this.props.getAllSurveys();
    }
  }

  // https://stackoverflow.com/questions/37112218/css3-100vh-not-constant-in-mobile-browser
  appHeight = () => {
    document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
  }

  render() {
    return (
      <div>
        <Router className="column-flex-container">
          <Modal />
          <NavBar />
          <Switch>
            <Route path="/" exact component={LandingPage} />
            <Route path="/resetpassword/:email/:hash" render={() => <LandingPage resetPassword />} />
            <PrivateRoute path="/dashboard" exact component={Dashboard} />
            <PrivateRoute path="/survey/:surveyid" component={SurveyPage} />
            <Route path="/faq" component={Faq} />
            <Route path="/about" component={About} />
            <PrivateRoute path="/results/:surveyid" component={ResultsPage} />
            <PrivateRoute path="/dashboard/allsurveys" exact component={AllSurveys} />
            <PrivateRoute path="/dashboard/account" exact component={Profile} />
            <PrivateRoute path="/dashboard/favorites" exact component={Favorites} />
            <PrivateRoute path="/dashboard/account/notifications" component={Notifications} />
            <PrivateRoute path="/dashboard/account/password" component={Password} />
            <PrivateRoute path="/dashboard/account/demographics" component={Demographics} />
            <Route component={FourOhFour} />
          </Switch>
        </Router>
      </div>
    );
  }
}

const mapStateToProps = (state) => (
  {
    modal: state.modal.toggle,
    surveys: state.survey.surveys,
    userid: state.user.userid,
    auth: state.user.authenticated,
  }
);

export default connect(mapStateToProps, {
  getAllSurveys, signinUser, getUserData,
})(App);
